import React from 'react';
import {RouteProps} from "react-router";
import {Route} from "react-router-dom";
import {content, contentWrapper, root} from "../TabsRoute/styles";


export const ContentRoute: React.FC<RouteProps> = (props) => {
    return (
        <div css={root}>
            <div css={contentWrapper}>
                <div css={content}>
                    <Route {...props} />
                </div>
            </div>
        </div>
    );
};